import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RefundStatusErrorDialogComponent } from './components/refund-status-error-dialog/refund-status-error-dialog.component';
import { RefundStatusInProgressComponent } from './components/refund-status-in-progress/refund-status-in-progress.component';
import { RefundStatusNotRefundedComponent } from './components/refund-status-not-refunded/refund-status-not-refunded.component';
import { RefundStatusRefundedComponent } from './components/refund-status-refunded/refund-status-refunded.component';
import { PipeModule } from '../pipe/pipe.module';
import { CommonModule } from '@angular/common';
import { RefundStatusLookupRedirectComponent } from './components/refund-status-lookup-redirect/refund-status-lookup-redirect.component';
import { CancelRefundComponent } from 'src/app/components/cancel-refund/cancel-refund.component';
import { RefundStatusLookUpComponent } from './components/refund-status-look-up/refund-status-look-up.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RefundStatusRoutingModule } from './refund-status-routing.module';

import '@aileron-web/footer';
import '@aileron-web/header';
import '@aileron/button';
import '@aileron/card';
import '@aileron/date-picker';
import '@aileron/dialog';
import '@aileron/icon';
import '@aileron/link';
import '@aileron/list';
import '@aileron/loading';
import '@aileron/notification';
import '@aileron/select';
import '@aileron/tailwind';
import '@aileron/text-input';
import '@aileron/tooltip';
import '@aileron/number-input';
import '@aileron/dropdown';

@NgModule({
  declarations: [
    RefundStatusErrorDialogComponent, 
    RefundStatusInProgressComponent, 
    RefundStatusNotRefundedComponent, 
    RefundStatusRefundedComponent,
    RefundStatusLookupRedirectComponent,
    CancelRefundComponent,
    RefundStatusLookUpComponent
  ],
  imports: [
    CommonModule,
    PipeModule,
    RefundStatusRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RefundStatusModule { }
